module.exports = __webpack_public_path__ + "media/application/images/icons/chart-gray-642b957143c97dc6853d1c9d85c083df.png";